import { createWithEqualityFn as create } from 'zustand/traditional'
import { createJSONStorage, persist } from 'zustand/middleware'

interface DateRangeState {
  dateRanges: Record<number, { minDate?: string; maxDate?: string }>
  setDateRange: (shareId: number, minDate?: string, maxDate?: string) => void
  getDateRange: (shareId: number) => { minDate?: string; maxDate?: string }
  clearDateRange: (shareId: number) => void
  clearAllDateRanges: () => void
}

export const useDateRangeStore = create(
  persist<DateRangeState>(
    (set, get) => ({
      dateRanges: {},
      setDateRange: (shareId: number, minDate?: string, maxDate?: string) =>
        set((state) => ({
          dateRanges: {
            ...state.dateRanges,
            [shareId]: {
              minDate: minDate ?? state.dateRanges[shareId]?.minDate,
              maxDate: maxDate ?? state.dateRanges[shareId]?.maxDate,
            },
          },
        })),
      getDateRange: (shareId: number) => {
        const state = get()
        return state.dateRanges[shareId] || {}
      },
      clearDateRange: (shareId: number) =>
        set((state) => {
          const newDateRanges = { ...state.dateRanges }
          delete newDateRanges[shareId]
          return { dateRanges: newDateRanges }
        }),
      clearAllDateRanges: () => set({ dateRanges: {} }),
    }),
    {
      name: 'smart-shares-date-ranges',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
